<template>
  <!-- Landscape block. A normal mobile browser tab cannot programmatically lock
       orientation (screen.orientation.lock requires fullscreen/installed PWA and
       is unsupported on iOS Safari), so we block landscape with CSS instead: the
       overlay is display:none by default and only shown on phone-sized landscape
       viewports (issue #289). -->
  <div class="orientation-guard" role="alertdialog" aria-modal="true">
    <svg
      class="orientation-guard__icon"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" stroke-width="1.5" />
      <path
        d="M2.5 14a9.5 9.5 0 0 1 9.5-9.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M12 4.5 9.5 6.5M12 4.5l-2 2.5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- This overlay is always mounted but display:none until a phone-landscape
         viewport shows it, so display:none keeps it out of the accessibility tree
         (and thus out of every other screen's heading count) until then. -->
    <div class="orientation-guard__heading" role="heading" aria-level="2">
      {{ STRINGS.ui.orientation.heading }}
    </div>
    <p class="orientation-guard__message">{{ STRINGS.ui.orientation.message }}</p>
  </div>
</template>

<script setup lang="ts">
import STRINGS from '@/constants/strings';
</script>

<style scoped>
.orientation-guard {
  display: none;
}

/* Only intervene on phone-sized landscape viewports; desktop landscape is fine. */
@media (orientation: landscape) and (max-width: 900px) {
  .orientation-guard {
    position: fixed;
    inset: 0;
    z-index: 100000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 24px;
    text-align: center;
    background: var(--color-arena-void);
    color: var(--color-arena-text-bright);
  }
}

.orientation-guard__icon {
  width: 56px;
  height: 56px;
  color: var(--color-energy-primary, var(--color-primary-500));
}

.orientation-guard__heading {
  font-family: var(--font-display, var(--font-sans));
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin: 0;
}

.orientation-guard__message {
  max-width: 32ch;
  font-size: 15px;
  line-height: 1.5;
  color: var(--color-arena-text-muted);
  margin: 0;
}
</style>
